<template>
  <div class="anketa">
    <h1>Пройдите тестирование</h1>
    <div class="anketa__data" v-for="(item, index) in data.anketa" :key="index">
      <div class="question">{{ index + 1 }}. {{ item.desc }}</div>
      <div class="answers-wrapper">
        <div class="answer" v-for="(answ, i) in item.answers" :key="i">
          <label>
            <input style="margin-right: 10px;" :name="'q'+item.id" type="radio" v-model="answers[item.id]"
                   :value="Number(answ.id)">
            <span> {{ answ.desc }} </span>
          </label>
          <p></p>
        </div>
      </div>
    </div>
    <div v-if="errors.length > 0" class="errors">
      <h2 v-for="(error, key) in errors" :key="key" style="color: red; font-size: 22px">{{ error }}</h2>
    </div>
    <button @click.prevent="checkAnswers" class="anketa__check">Проверить</button>
  </div>
</template>

<script>
import axios from "axios";
import {baseURL} from "@/create/composables/const";

export default {
  name: "AnketaComponent",
  props: ["data"],
  data: () => {
    return {
      answers: {},
      errors: []
    };
  },
  methods: {
    async checkAnswers() {
      this.errors = [];
      if (Object.keys(this.answers).length < this.data.anketa.length) {
        this.errors.push("Ответы не на все вопросы выбраны");
        return;
      }

      try {
        const response = await axios.post(baseURL, {
          ver: 0,
          action: "landing_signer_check_anketa",
          object: "contract",
          slug: this.$route.params.slugID,
          anketa_result: this.answers,
          login: "ybrir",
        });

        if (response.data.result) {
          this.$emit('successfulAnketaCheck');
        }
        if (response.data.error) {
          this.errors.push(response.data.error);
        }
      } catch (e) {
        console.log("Frontend checkAnswers Error - " + e);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.anketa {
  display: flex;
  flex-direction: column;
  width: 1440px;
  margin: 15px auto;

  @media only screen and (max-width: 1450px) {
    width: 1240px;
  }

  @media only screen and (max-width: 450px) {
    width: 95%;
  }

  .anketa__data {
    margin-top: 10px;

    .question {
      padding-left: 15px;
      font-weight: 700;

      @media only screen and (max-width: 450px) {
        font-size: 14px;
        padding-left: 10px;
        padding-right: 10px;
      }
    }

    .answers-wrapper {
      padding-left: 30px;
      padding-top: 10px;
      padding-bottom: 10px;

      @media only screen and (max-width: 450px) {
        padding-left: 10px;
        padding-right: 10px;
      }

      .answer {
        @media only screen and (max-width: 450px) {
          font-size: 12px;
        }
      }
    }
  }

  button.anketa__check {
    padding: 10px;
    background: #0062cc;
    color: #FFFFFF;
    border: 2px solid #005cbf;
    outline: #0075D4;
    cursor: pointer;
    font: 700 20px SourceSansPro, sans-serif;
    line-height: normal;
    border-radius: .3rem;
    width: 250px;
    margin-top: 10px;
  }
}
</style>